export default {
    "updated": "Plata PayU a fost actualizata cu succes",
    "deleted": "Plata PayU a fost ștearsa cu succes",
    "restored": "Plata PayU a fost restaurata cu succes",
}
